import { Component, Input, signal } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-ui-code-block',
	imports: [SharedModule],
	templateUrl: './ui-code-block.component.html',
	styleUrl: './ui-code-block.component.scss',
})
export class UiCodeBlockComponent {
	@Input({ required: true }) code!: string;

	copied = signal(false);

	async copyCode(): Promise<void> {
		try {
			await navigator.clipboard.writeText(this.code);
			this.copied.set(true);
			setTimeout(() => this.copied.set(false), 2000);
		} catch (err) {
			console.error('Failed to copy code:', err);
		}
	}
}
